import { createServerOnlyFn } from "@tanstack/react-start";
import { z } from "zod";
import {
    handleCreateMcpConnectionLinkRequest,
    handleMcpConnectionDonePageRequest,
    handleMcpConnectionLinkPageRequest,
} from "./mcp-connection-link.server.ts";
import { mcpServerIdSchema } from "./mcp-connection.contract.ts";
import { MCP_CONNECTION_LINK_HEADERS } from "./mcp-connection-link-headers.ts";

const handleLinkPage = createServerOnlyFn(
    ({ request, params }: { request: Request; params: { token: string } }) =>
        handleMcpConnectionLinkPageRequest(request, params.token),
);

export const mcpConnectionLinkApiRoute = {
    server: {
        handlers: {
            POST: createServerOnlyFn(({ request }: { request: Request }) =>
                handleCreateMcpConnectionLinkRequest(request),
            ),
        },
    },
};

export const mcpConnectionLinkPageRoute = {
    server: { handlers: { GET: handleLinkPage, POST: handleLinkPage } },
};

export const mcpConnectionDonePageRoute = {
    server: {
        handlers: {
            GET: createServerOnlyFn(({ request }: { request: Request }) =>
                handleMcpConnectionDonePageRequest(request),
            ),
        },
    },
};

const landingSearchSchema = z
    .object({
        serverId: mcpServerIdSchema.optional().catch(undefined),
        provider: mcpServerIdSchema.optional().catch(undefined),
        link: z.uuid().optional().catch(undefined),
    })
    .transform(({ serverId, provider, link }) => ({
        serverId: serverId ?? provider,
        link,
    }));

export const mcpConnectionLinkLandingRoute = {
    validateSearch: landingSearchSchema,
    ssr: false as const,
    head: () => ({
        meta: [
            { title: "Connect an account | Wags" },
            { name: "robots", content: "noindex, nofollow" },
        ],
    }),
    headers: () => ({
        "Cache-Control": MCP_CONNECTION_LINK_HEADERS["cache-control"],
        "Referrer-Policy": MCP_CONNECTION_LINK_HEADERS["referrer-policy"],
        "X-Robots-Tag": MCP_CONNECTION_LINK_HEADERS["x-robots-tag"],
    }),
};
